import { NgTemplateOutlet } from '@angular/common'
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  ViewChild
} from '@angular/core'
import { Router } from '@angular/router'

import { BannerContent, Section } from 'app/_shared/interfaces/config'
import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-banner',
  imports: [NgTemplateOutlet],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent implements OnInit, AfterViewInit {
  @ViewChild('bannerVideo') bannerVideo?: ElementRef<HTMLVideoElement>

  appConfigService = inject(AppConfigService)
  router = inject(Router)

  section = input.required<Section<BannerContent>>()
  video = signal('')

  storefrontId = this.appConfigService.getAppConfig.id

  ngOnInit() {
    if (this.router.url === '/' && this.storefrontId === 78) {
      this.video.set(
        'https://single-serve-store.s3.us-east-1.amazonaws.com/companies/23/storefronts/78/New_BobShop_Banner_4.mp4'
      )
    }
  }

  ngAfterViewInit() {
    const el = this.bannerVideo?.nativeElement
    if (el) {
      el.muted = true
      el.play().catch(() => {})
    }
  }
  formatUrl(raw?: string): string {
    const u = (raw ?? '').trim()
    if (!u) return '#'
    // if starts with http(s) or protocol-relative, keep it; otherwise prefix https
    if (/^(https?:)?\/\//i.test(u)) return u.startsWith('//') ? `https:${u}` : u
    return `https://${u}`
  }
}
